module.exports = __webpack_public_path__ + "img/guru_teaching1.0d83a85d.png";